import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=fbb9d7e4&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb9d7e4')) {
      api.createRecord('fbb9d7e4', component.options)
    } else {
      api.reload('fbb9d7e4', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=fbb9d7e4&", function () {
      api.rerender('fbb9d7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/DataTable.vue"
export default component.exports